import EventTask from 'forms/containers/Events/EventTask';
export default EventTask;
